export const LicenseType = {
  SEC: 'SEC',
  LIF: 'LIF',
  AH: 'A&H',
} as const;
